import { DebounceInput } from 'react-debounce-input';
import styled from 'styled-components';
import { styles, mixins } from '4all-ui/styles';
import IconSearch from '../../images/icon-search.svg';
import IconClose from '../../images/icon-close.svg';

export const Container = styled.div`
  ${mixins.flexPosition({ align: 'center', justify: 'space-between' })}
`;

export const ButtonContainer = styled.div`
  ${mixins.flexPosition({ align: 'center', justify: 'space-between' })}
  width: 100%;
`;

export const Button = styled.button`
  background-color: transparent;
  border: none;
  ${mixins.fontStyle(
    styles.colors.INFO_COLOR,
    styles.fontSizes.SIZE_7,
    styles.fontWeights.SEMIBOLD
  )}
`;

export const Info = styled.div`
  padding-right: 50px;
  text-align: left;
`;

export const Title = styled.h2`
  ${mixins.fontStyle(styles.colors.GRAY_DARKER, styles.fontSizes.SIZE_4, styles.fontWeights.NORMAL)}
  margin: 0 0 10px;
`;

export const Desc = styled.p`
  ${mixins.fontStyle(
    styles.colors.GRAY_MEDIUM_3,
    styles.fontSizes.SIZE_7,
    styles.fontWeights.SEMIBOLD
  )}
  margin: 0;

  a {
    text-decoration: underline;
  }
`;

export const InputContainer = styled.div`
  margin-top: 15px;
  ${mixins.flexPosition({ align: 'center', justify: 'space-between' })}
  position: relative;
  width: ${({ inputSize }) => inputSize};
`;

export const InputSearch = styled(DebounceInput)`
  border: 1px solid ${styles.colors.GRAY_LIGHT_2};
  border-radius: 3px;
  ${mixins.fontStyle(
    styles.colors.GRAY_DARKER,
    styles.fontSizes.SIZE_7,
    styles.fontWeights.SEMIBOLD
  )}
  ${mixins.flexPosition({
    align: 'center',
    justify: 'space-between',
  })}
  height: 45px;
  padding: 12px 35px 12px 15px;
  width: 100%;

  /*...global variations...*/
  &::-webkit-input-placeholder {
    ${mixins.fontStyle(
      styles.colors.GRAY_MEDIUM_3,
      styles.fontSizes.SIZE_7,
      styles.fontWeights.SEMIBOLD
    )};
  }
`;

const Icon = styled.span`
  background-repeat: no-repeat;
  ${mixins.flexPosition({})}
  height: 18px;
  position: absolute;
  right: 10px;
  width: 18px;
`;

export const SearchIcon = styled(Icon)`
  background-image: url(${IconSearch});
`;

export const CloseIcon = styled(Icon)`
  background-image: url(${IconClose});
  background-position: center center;
  cursor: pointer;
  height: 45px;
  padding: 17px 14px;
  right: 0;
  width: 37px;
`;



// WEBPACK FOOTER //
// ./src/components/GenericListHeader/style.js